const resumeStepsData = [
    {
      direction: false,
      numberCnt: 1,
      title: "Pick a Template",
      desc: "Choose from a variety of professionally designed templates to kickstart your resume.",
      imageLink: "https://res.cloudinary.com/dkynwi65w/image/upload/v1734285813/tempLateSelection_gbewij.jpg"
    },
    {
      direction: true,
      numberCnt: 2,
      title: "Edit Template",
      desc: "Customize your selected template with your personal details and career information.",
      imageLink: "https://res.cloudinary.com/dkynwi65w/image/upload/v1734285820/templateEditing_rawaxw.jpg"
    },
    {
      direction: false,
      numberCnt: 3,
      title: "Build a Resume",
      desc: "Fill in your work experience, education, and skills to craft a standout resume.",
      imageLink: "https://res.cloudinary.com/dkynwi65w/image/upload/v1734285807/resumeCreating_bsjyyu.jpg"
    },
    {
      direction: true,
      numberCnt: 4,
      title: "Download Resume",
      desc: "Download your completed resume in a PDF format, ready for job applications.",
      imageLink: "https://res.cloudinary.com/dkynwi65w/image/upload/v1734285800/dowload_ywsvq9.jpg"
    }
  ];

  export default resumeStepsData;